export default (state, action) => ({
  ...state,
  validationResult: { ...action.payload },
});
